export interface NmeaData {
    Latitude?: number;
    Longitude?: number;
    Heading?: number;
    HorizontalPrecision?: number;
    Altitude?: number;
    NumberOfSatellites?: number;
    Speed?: number;
    RawNmeaMessage?: string;
}

export interface ExpandedNmeaData extends NmeaData {
    Date: string;
}

export enum SksdStatus {
    Udefinert = 0,
    Underkjent = 1,
    Godkjent = 2,
    Sendt = 3,
    Ubehandlet = 4,
}

export interface SksdTransferResponse {
    globalId: string;
    layerId: number;
    success: boolean;
    message?: string;
    fileName?: string;
}

export interface AttributeValidationError {
    attributeName: string;
    errorMessage: string;
    relatedFeatureClassName?: string | null;
}

export interface NauticalObjectValidationResult {
    layerId: number;
    globalId: string;
    errors: AttributeValidationError[];
    isValid: boolean;
}

export interface LayerSetting {
    parent: LayerSetting | null;
    layerType: string;
    url: string;
    layerId: number;
    title: string;

    opacity: number;
    zoomLevel: number;
}

export interface MapSettings {
    basemap: { layerType: string; type: string; url: string }[]; //
    enabledLayers: LayerSetting[];
    /** The user's label field selection. Kept even while labels are toggled off. */
    enabledLabels: string[];
    /** Whether the selected labels are currently shown in the map. */
    labelsEnabled: boolean;
}

/**
 * Map settings as they come out of localStorage. Entries written before the label fields
 * existed are missing them, so they are optional until `normalizeMapSettings` fills them in.
 */
export type StoredMapSettings = Omit<MapSettings, "enabledLabels" | "labelsEnabled"> &
    Partial<Pick<MapSettings, "enabledLabels" | "labelsEnabled">>;
